import DataTableColumn from '@/shared/components/dataTable/dataTableColumn';

export const contactColumns = [
	{
		display: 'Name',
		name: 'name',
		sortable: false,
		clickable: true,
		icon: 'PersonIcon'
	},
	{
		display: 'Email',
		name: 'email',
		sortable: true,
		clickable: false,
		icon: 'EmailIcon'
	},
	{
		display: 'Phone Number',
		name: 'phoneNumber',
		sortable: true,
		clickable: false,
		icon: 'PhoneIcon'
	},
	{
		display: 'Last Seen',
		name: 'lastSeen',
		sortable: true,
		clickable: false,
		icon: 'CalendarIcon'
	},
	{
		display: 'Last Contacted',
		name: 'lastContacted',
		sortable: true,
		clickable: false,
		icon: 'CalendarIcon'
	},
	{
		display: 'Last Heard From',
		name: 'lastHeardFrom',
		sortable: true,
		clickable: false,
		icon: 'CalendarIcon'
	},
	{
		display: 'First Seen',
		name: 'firstSeen',
		sortable: true,
		clickable: false,
		icon: 'CalendarIcon'
	},
] as DataTableColumn[];




